import PUBLIC_PATH from "@/src/routes/public/path";

export const FOOTER_LINKS = {
  TERMS_OF_USE: `${PUBLIC_PATH.TERMS}?defaultTab=termsOfUse`,
  PRIVACY_POLICY: `${PUBLIC_PATH.TERMS}?defaultTab=privacyPolicy`,
  CONTACT_US: PUBLIC_PATH.CONTACT_US,
} as const;
